/* eslint-disable @typescript-eslint/member-ordering */
import { Component, computed, input, InputSignal, output } from '@angular/core';
import { DrawerResult, DrawerState } from '../../drawer.model';
import { IconComponent } from '../../../../icons';
import { DrawerService } from '../../drawer.service';
import { NgClass } from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'da-drawer-footer',
  standalone: true,
  imports: [IconComponent, NgClass],
  templateUrl: './drawer-footer.component.html',
})
export class DrawerFooterComponent {
  public drawer: InputSignal<DrawerState> = input.required();
  public close = output<DrawerResult>();

  public showFooter = computed(() => {
    const drawer = this.drawer();

    if (!drawer?.buttons) {
      return false;
    }

    return !!(
      drawer?.buttons.primaryButton.visible ||
      drawer?.buttons.secondaryButton.visible ||
      drawer?.buttons.tertiaryButton.visible
    );
  });

  constructor(private drawerService: DrawerService) {}

  public tertiaryButtonClicked(): void {
    this.drawerService.buttons.tertiaryButton.clicked$.next();
  }

  public secondaryButtonClicked(): void {
    this.drawerService.buttons.secondaryButton.clicked$.next();
  }

  public primaryButtonClicked(): void {
    this.drawerService.buttons.primaryButton.clicked$.next();
  }
}
